import { client } from "api";
import { Category, Checklist } from "models/Checklist";

export type CreateChecklistRequest = {
  orderId: string;
  roomName: string;
  categories: Category[];
};

export type CreateChecklistResponse = Checklist;

export const createChecklist = ({ orderId, ...data }: CreateChecklistRequest) =>
  client.post<CreateChecklistResponse>(`/checklist/${orderId}`, data).then((res) => res.data);
